/* Top Racing Point - menu a tendina scorrevole con la rotella su schermi bassi (solo computer).
   1) Quando il menu aperto e' piu' alto della finestra, gli da' un'altezza massima e una barra propria.
   2) La rotella del mouse, ovunque sopra il menu aperto, fa scorrere il menu (il tema bloccava la rotella sul contenuto). */
(function(){
  var SEL = '.mega-menu, .nav-dropdown';
  function sistema(menu){
    if(!menu || window.innerWidth < 750) return;
    var top = menu.getBoundingClientRect().top;
    var max = Math.max(200, window.innerHeight - Math.max(top, 0) - 12);
    menu.style.maxHeight = max + 'px';
    menu.style.overflowY = 'auto';
    menu.style.overscrollBehavior = 'contain';
    menu.setAttribute('data-trp-scroll', '1');
  }
  function apri(e){
    var item = e.target.closest && e.target.closest('.nav-bar__item');
    if(!item) return;
    var m = item.querySelector(SEL);
    if(m){ sistema(m); requestAnimationFrame(function(){ sistema(m); }); setTimeout(function(){ sistema(m); }, 250); }
  }
  function rotella(e){
    if(window.innerWidth < 750 || !e.target.closest) return;
    var m = e.target.closest('[data-trp-scroll]');
    if(!m || m.scrollHeight <= m.clientHeight + 1) return;
    var dy = e.deltaY;
    if(e.deltaMode === 1) dy *= 16; else if(e.deltaMode === 2) dy *= m.clientHeight;
    var prima = m.scrollTop;
    m.scrollTop = prima + dy;
    e.preventDefault();
    e.stopPropagation();
  }
  document.addEventListener('mouseover', apri, true);
  document.addEventListener('focusin', apri, true);
  window.addEventListener('wheel', rotella, { capture: true, passive: false });
  window.addEventListener('resize', function(){
    [].forEach.call(document.querySelectorAll('[data-trp-scroll]'), function(m){ m.style.maxHeight=''; });
  });
})();
